import Key from "./Key";

function Keyboard(props) {
  return (
    <div className="keyboard">
      {["QWERTYUIOP", "ASDFGHJKL", "ZXCVBNM"].map((row, i) => {return (
        <div key={row} className="key-row" style={{ "--num-keys": row.length }}>
          {i === 2 ? <Key letter="ENTER" margin={true} handleInput={props.handleInput} /> : ""}
          {[...row].map((letter, j) =>
            <Key
              key={letter}
              letter={letter}
              guesses={props.guesses}
              target={props.target}
              margin={ j !== row.length - 1 || i === 2}
              handleInput={props.handleInput}
            />)
          }
          {i === 2 ? <Key letter="BACK" margin={false} handleInput={props.handleInput} /> : ""}
        </div>
      )})}
    </div>
  );
}

export default Keyboard;